import { TFunction } from 'i18next';
import { MessagesInformationDto } from '../../../../interfaces/dtos/MessagesInformationDto';
import { MessagesInformation } from '../../../../interfaces/MessagesInformation';
import transformPagination from '../transformPagination/transformPagination';
import transformMessages from '../transformMessages/transformMessages';

export default function transformMessagesInformation(dto: MessagesInformationDto, t: TFunction<'SecureMessagingPage'>): MessagesInformation {
  return {
    data: transformMessages(dto.data, t),
    pagination: transformPagination(dto.pagination),
    canWrite: dto.behaviours?.permissionLevel?.canWrite,
  } as MessagesInformation;
}
